var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29 14a1 1 0 0 0 1-1v-5a2 2 0 0 0 -2-2h-24a2 2 0 0 0 -2 2v5a1 1 0 0 0 1 1 2 2 0 0 1 0 4 1 1 0 0 0 -1 1v5a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2v-5a1 1 0 0 0 -1-1 2 2 0 0 1 0-4zm-1 5.87v4.13h-7v-3h-2v3h-15v-4.13a4 4 0 0 0 0-7.74v-4.13h15v3h2v-3h7v4.13a4 4 0 0 0 0 7.74z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19 13h2v6h-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h32v32h-32z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.a4e46f21d1141c9f2dadcdaa5e4f9ae4.svg";
export { ForwardRef as ReactComponent };